var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1878_50384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0494 5.5C16.0262 5.69057 16.9238 6.16826 17.6275 6.87194C18.3312 7.57561 18.8089 8.47326 18.9994 9.45M15.0494 1.5C17.0787 1.72544 18.971 2.63417 20.4157 4.07701C21.8603 5.51984 22.7715 7.41101 22.9994 9.44M21.9994 17.42V20.42C22.0006 20.6985 21.9435 20.9742 21.832 21.2293C21.7204 21.4845 21.5567 21.7136 21.3515 21.9019C21.1463 22.0901 20.904 22.2335 20.6402 22.3227C20.3764 22.4119 20.0968 22.4451 19.8194 22.42C16.7423 22.0856 13.7864 21.0341 11.1894 19.35C8.77327 17.8147 6.72478 15.7662 5.18945 13.35C3.49942 10.7412 2.44769 7.77099 2.11944 4.68C2.09446 4.40347 2.12732 4.12476 2.21595 3.86162C2.30457 3.59849 2.44702 3.35669 2.63421 3.15162C2.82141 2.94655 3.04925 2.78271 3.30324 2.67052C3.55722 2.55833 3.83179 2.50026 4.10945 2.5H7.10945C7.59475 2.49522 8.06524 2.66708 8.43321 2.98353C8.80118 3.29999 9.04152 3.73945 9.10944 4.22C9.23607 5.18007 9.47089 6.12273 9.80945 7.03C9.94399 7.38792 9.97311 7.77691 9.89335 8.15088C9.8136 8.52485 9.62831 8.86811 9.35944 9.14L8.08945 10.41C9.513 12.9135 11.5859 14.9864 14.0894 16.41L15.3594 15.14C15.6313 14.8711 15.9746 14.6858 16.3486 14.6061C16.7225 14.5263 17.1115 14.5555 17.4694 14.69C18.3767 15.0286 19.3194 15.2634 20.2794 15.39C20.7652 15.4585 21.2088 15.7032 21.526 16.0775C21.8431 16.4518 22.0116 16.9296 21.9994 17.42Z",
    stroke: "#8697A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1878_50384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.2f06f8bb2d2297a2001895219ec3dcae.svg";
export { ForwardRef as ReactComponent };